import {Injectable} from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import {Page} from "../../utils/page";
import { CmcProtocol } from '../../models/cmc/cmc-protocol.model';
import {TranslateService} from "@ngx-translate/core";
import {CmcProtocolService} from "./cmc-protocol.service";

@Injectable()
export class OnlineCmcProtocolService extends CmcProtocolService {
    API_URL = '/apiClientManager/v1';    

    constructor(
        private http: HttpClient,
        protected translateService: TranslateService) {
        super(translateService);
    }

    searchProtocols(countryIsoCode: string, userRole: string, pageable: Map<string, string>, searchParam: string) {
        let params = new HttpParams()
            .set('countryIsoCode', countryIsoCode)
            .set('rolesOpen', userRole);

        if (searchParam) {
            params = params.set('searchParam', searchParam);
        }
        pageable.forEach((value, key) => params = params.set(key, value));

        const url = `${this.API_URL + '/cmc-protocols'}`;
        return this.http.get<Page<CmcProtocol>>(url, {params});
    }

    getCmcProtocol(cmcCode: string, countryIsoCode: string, role: string) {
        const url = `${this.API_URL}/cmc-protocols/${cmcCode}/${countryIsoCode}/${role}`;
        return this.http.get<CmcProtocol>(url);
    }

}
